import styled from 'styled-components';

import { MobileScreen } from '../styles/ConstantMediaQuery';
import ColorConstants from '../../constants/ColorConstants';

// TODO(JG): O componente da automatic header modal deve utilizar esses componentes
const ModalHeaderTitle = styled.h1`
    color: ${ColorConstants.white};
    font-family: "Helvetica";
    font-size: 24px;
    font-weight: bold;
    text-align: center;
    
    @media ${MobileScreen} {
        font-size: 24px;
        line-height: 1;
        margin-bottom: 10px;
    }
`;

const ModalHeaderSubtitle = styled.h3`
    color: #ffffff;
    font-family: "Helvetica";
    font-size: 15px;
    font-weight: 400;
    line-height: 1;
    margin: 0 0 15px 0;
    text-align: center;
    
    @media ${MobileScreen} {
        margin-bottom: 10px;
    }
`;

const ModalHeaderLogo = styled.img`
    border-radius: 50%;
    height: 53px;
    margin-top: 30px;
    width: 53px;
`;

export {
    ModalHeaderLogo,
    ModalHeaderTitle,
    ModalHeaderSubtitle,
};
